import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardTile from './DashboardTile';
import type { Hub } from '@/types/dashboard';

interface QuickLinksGridProps {
  hubs: Hub[];
}

const QuickLinksGrid: FC<QuickLinksGridProps> = ({ hubs }) => {
  const navigate = useNavigate();

  const getRoute = (id: string) => {
    if (id === 'trails') return '/trilhas';
    if (id === 'play') return '/jogar';
    return '';
  };

  // Esconde hubs "Em breve" — mostrar funcionalidades inexistentes polui
  // cognitivamente, principalmente para a persona leiga.
  const activeHubs = hubs.filter((h) => !h.comingSoon).slice(0, 4);

  return (
    <DashboardTile data-testid="quick-links-tile">
      <div className="grid grid-cols-2 gap-2 h-full">
        {activeHubs.map((hub) => {
          const isDisabled = !hub.isActive;
          const route = getRoute(hub.id);

          return (
            <div
              key={hub.id}
              onClick={isDisabled ? undefined : () => navigate(route)}
              role={isDisabled ? undefined : 'button'}
              tabIndex={isDisabled ? undefined : 0}
              onKeyDown={isDisabled ? undefined : (e) => { if (e.key === 'Enter') navigate(route); }}
              className={`
                rounded-lg p-3 flex flex-col gap-1.5 transition-all
                ${isDisabled ? 'opacity-35 cursor-default' : 'cursor-pointer hover:scale-[1.02]'}
              `}
              style={{ background: 'var(--tile-mini-bg)' }}
            >
              <span
                className="material-symbols-outlined text-xl"
                style={{ color: isDisabled ? 'var(--tile-text-muted)' : 'var(--tile-accent)' }}
              >
                {hub.icon}
              </span>
              <div>
                <p className="text-xs font-bold" style={{ color: 'var(--tile-text-primary)' }}>
                  {hub.title}
                </p>
                <p className="text-2xs" style={{ color: 'var(--tile-text-muted)' }}>
                  {hub.comingSoon ? '(Em breve)' : hub.subtitle}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </DashboardTile>
  );
};

export default QuickLinksGrid;
